import {
    Pipe,
    PipeTransform,
} from "@angular/core";
import { eventThemeDefault } from "../constants/event-theme.constants";

@Pipe({
    name: "checkEventThemePipe",
    standalone: true,
})
export class CheckEventThemePipe implements PipeTransform {
    public transform(eventTheme: string): boolean {
        return eventTheme !== eventThemeDefault;
    }
}
